import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CancelToken, isCancel } from 'axios';

import {
  XIRGO_V1_VENDOR_ID,
  XIRGO_V2_VENDOR_ID,
} from '../../Constants/Vendors';
import AssetService from '../../Services/AssetService';
import ZipFile from '../../Lib/ZipFile';

import NewCertificateModalDisplay from './NewCertificateModalDisplay';

export default class NewCertificateModalContainer extends Component {
  state = {
    viewing: 'create',
    certificate: null,
    error: null,
    certRequestPending: false,
    downloadPending: false,
  };

  assetService = new AssetService();
  source = CancelToken.source();

  componentWillUnmount() {
    this.source.cancel();
  }

  generateCertificate = async () => {
    this.setState({ certRequestPending: true });
    try {
      const {
        asset: { _id: assetID, vendor, mac, nickname, orgID, gtemplateID },
        handleXirgoCertUpdated,
      } = this.props;

      switch (vendor) {
        case XIRGO_V1_VENDOR_ID:
        case XIRGO_V2_VENDOR_ID:
          {
            await this.assetService.generateCertificate(
              assetID,
              this.source.token
            );
            handleXirgoCertUpdated();
          }
          break;
        case 'elevat':
          await this.assetService.ProvisionAssetBulk(
            [
              {
                gatewayName: nickname,
                serialNumber: mac,
                type: 'rekey',
                templateID: gtemplateID,
                gatewayId: assetID,
              },
            ],
            orgID
          );
          this.setState({ viewing: 'confirm' }); // show the confirm view with a message to emphasize that the asset is now in the provisioning queue
          break;
        default:
          {
            // I guess for danfoss? proceed with the download which is a 2nd stage in the dialog
            const certificate = await this.assetService.generateCertificate(
              assetID,
              this.source.token
            );
            this.setState({ certificate, viewing: 'confirm' });
          }
          break;
      }
    } catch (err) {
      if (isCancel(err)) return;
      const error = err.reponse?.data?.message ?? err.message;
      this.setState({ error, certRequestPending: false });
    }
  };

  handleDownloadAndClose = async () => {
    this.setState({ downloadPending: true });
    try {
      const downloadParams = {
        ...this.state.certificate,
        gateway: this.props.asset,
      };
      const certZip = new ZipFile(downloadParams)
        .createFileNames()
        .queueZipFiles();
      await certZip.generateZipFile();
      certZip.downloadZipFile();
      this.props.toggleModal();
    } catch (err) {
      this.setState({ error: err.message, downloadPending: false });
    }
  };

  toggleView = () => {
    this.setState({ viewing: 'create' });
  };

  render() {
    return (
      <NewCertificateModalDisplay
        {...this.props}
        {...this.state}
        toggleView={this.toggleView}
        generateCertificate={this.generateCertificate}
        handleDownloadAndClose={this.handleDownloadAndClose}
      />
    );
  }
}

NewCertificateModalContainer.propTypes = {
  asset: PropTypes.object,
  handleXirgoCertUpdated: PropTypes.func,
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
};

NewCertificateModalContainer.defaultProps = { asset: {} };
